import type { AssignationWithOrderOperator } from "../operators/AssignationWithOrderOperator";

export function sortAndGroupAssignationWithOrderOperators(
    assignationWithOrderOperators: AssignationWithOrderOperator[],
): AssignationWithOrderOperator[] {
    return assignationWithOrderOperators
        .sort((a, b) => a.order.departureAt.getTime() - b.order.departureAt.getTime())
        .reduce<
            Array<AssignationWithOrderOperator>
        >((prev, curr) => [...prev, curr], [] as AssignationWithOrderOperator[]);
}
